import { cn } from '@/lib/utils';
import { Eye, EyeOff } from 'lucide-react';
import { memo, useState } from 'react';
import { Input, InputProps } from '../ui/input';

const InputPassword = (props: InputProps) => {
    const [show, setShow] = useState(false);

    return (
        <div className='relative [&>*]:outline-none'>
            <Input
                {...props}
                type={show ? 'text' : 'password'}
                className={cn(props.className, 'pr-7')}
            />

            <button
                type='button'
                tabIndex={-1}
                className='absolute right-2 top-1/2 -translate-y-1/2'
                onClick={() => setShow((st) => !st)}
            >
                {show ? (
                    <Eye size={16} className='text-gray-500' />
                ) : (
                    <EyeOff size={16} className='text-gray-500' />
                )}
            </button>
        </div>
    );
};

export default memo(InputPassword);
